type NotificationType = {
  label: string;
  value: string;
};

const notificationsTypes: NotificationType[] = [
  {
    label: 'Comments',
    value: 'comments',
  },
  {
    label: 'Posts',
    value: 'posts',
  },
  {
    label: 'Messages',
    value: 'messages',
  },
];

export default notificationsTypes;
